export interface FAQItem {
  question: string;
  answer: string;
}

export const CAT_FAQ: FAQItem[] = [
  {
    question: 'Trắc nghiệm hướng nghiệp CAT là gì?',
    answer:
      'CAT (Career Aptitude Test) là công cụ đánh giá năng lực và định hướng nghề nghiệp dành cho học sinh THPT. Bài test giúp bạn khám phá sở thích, tính cách và năng lực để chọn ngành học phù hợp.',
  },
  {
    question: 'Bài test CAT mất bao lâu để hoàn thành?',
    answer:
      'Bài test CAT thường mất khoảng 15-20 phút để hoàn thành. Bạn nên làm trong môi trường yên tĩnh và trả lời thật lòng để kết quả chính xác nhất.',
  },
  {
    question: 'Kết quả test CAT có độ chính xác như thế nào?',
    answer:
      'Công cụ CAT đã được đăng ký bản quyền và thử nghiệm trên mẫu lớn tại Việt Nam. Độ chính xác phụ thuộc vào việc bạn trả lời trung thực và kỹ lưỡng. Kết quả sẽ cung cấp gợi ý về nhóm ngành phù hợp nhất với bạn.',
  },
  {
    question: 'Tôi có thể làm lại bài test không?',
    answer:
      'Có, bạn hoàn toàn có thể làm lại bài test. Tuy nhiên, kết quả chính xác nhất thường là lần đầu tiên khi bạn trả lời một cách tự nhiên nhất.',
  },
  {
    question: 'Báo cáo đầy đủ của CAT bao gồm những gì?',
    answer:
      'Báo cáo CAT bao gồm: phân tích chi tiết 6 nhóm ngành nghề Holland, điểm số cho từng nhóm, top 3 nhóm ngành phù hợp nhất, gợi ý ngành học cụ thể, và lời khuyên về lộ trình phát triển nghề nghiệp.',
  },
  {
    question: 'CAT test có miễn phí không?',
    answer:
      'Bài test CAT cơ bản hoàn toàn miễn phí. Bạn sẽ nhận được kết quả tổng quan về nhóm ngành phù hợp. Để xem báo cáo chi tiết với phân tích sâu và gợi ý cụ thể, bạn cần mở khóa báo cáo đầy đủ.',
  },
];
